import { render, staticRenderFns } from "./Lianxiwomen.vue?vue&type=template&id=f96932c8&scoped=true"
import script from "./Lianxiwomen.vue?vue&type=script&lang=js"
export * from "./Lianxiwomen.vue?vue&type=script&lang=js"
import style0 from "./Lianxiwomen.vue?vue&type=style&index=0&id=f96932c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96932c8",
  null
  
)

export default component.exports